const COOKIE_TOKEN_KEY = 'token';
const COOKIE_MAX_AGE = 60 * 60 * 24 * 7; // 7 días

export function getAuthToken(): string | null {
  if (typeof document === 'undefined') return null;
  const match = document.cookie
    .split('; ')
    .find((row) => row.startsWith(`${COOKIE_TOKEN_KEY}=`));
  return match ? decodeURIComponent(match.split('=')[1]) : null;
}

export function setAuthCookie(token: string): void {
  if (typeof document === 'undefined') return;
  document.cookie = `${COOKIE_TOKEN_KEY}=${encodeURIComponent(token)}; path=/; max-age=${COOKIE_MAX_AGE}; SameSite=Lax`;
}

export function removeAuthCookie(): void {
  if (typeof document === 'undefined') return;
  document.cookie = `${COOKIE_TOKEN_KEY}=; path=/; max-age=0; SameSite=Lax`;
}
